module.exports = __webpack_public_path__ + "vatican-city.svg?33151433a3fd86ea48104d363cef08a2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/vatican-city.svg
// module id = 337
// module chunks = 10